import React, { useMemo } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import FisheryDepartmentNotes from "./FisheryDepartmentNotes";
import { getFisheryDepartmentLandingNotesApi } from "api/registration";

const FisheryDepartmentLandingNote: React.FC = () => {
	const { id } = useParams();
	const { t } = useTranslation();

	// Safely convert id to number, returning undefined if invalid
	const numericId = useMemo(() => {
		if (!id) return undefined;
		const parsed = Number(id);
		return !isNaN(parsed) && parsed > 0 ? parsed : undefined;
	}, [id]);

	// Don't render the component if id is invalid
	if (numericId === undefined) {
		return (
			<div style={{ padding: "20px", textAlign: "center" }}>
				<p>{t("InvalidIdError") || "Invalid ID provided. Please select a valid record."}</p>
			</div>
		);
	}

	return (
		<FisheryDepartmentNotes
			id={numericId}
			title={t("FisheryDepartmentLandingNotes")}
			apiMethod={getFisheryDepartmentLandingNotesApi}
		/>
	);
};

export default FisheryDepartmentLandingNote;
